import { render } from "./FileTreeView.vue?vue&type=template&id=35027d0b"
import script from "./FileTreeView.vue?vue&type=script&lang=js"
export * from "./FileTreeView.vue?vue&type=script&lang=js"
script.render = render

export default script